var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('HeaderPc'),(!(_vm.$route.meta.showSelectHead && _vm.$route.meta.showSelectHead.mobile))?_c('HeaderM'):_vm._e(),_c('div',{staticClass:"jin-recruit-container"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }